export const useConvertElementStyles = (node: any) => {
  // Extract teh node's style attributes as key-value pairs
  const style = node.getAttribute("style");

  if (!style) return {};

  const styles = style.split(";");

  const styleObject = {} as any;

  for (const style of styles) {
    if (style == "") continue;

    const parts = style.split(":");

    if (parts.length != 2) continue;

    styleObject[parts[0].trim()] = parts[1].trim();
  }

  return styleObject;
};
